// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Book = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Book = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Book = _exports.Book = function Book(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M15.4173 1.875H5.83398C3.81898 1.875 2.70898 2.985 2.70898 5V15C2.70898 16.8692 3.96482 18.125 5.83398 18.125H15.4173C16.4507 18.125 17.2923 17.2842 17.2923 16.25V11.25V9.16667V3.75C17.2923 2.71583 16.4507 1.875 15.4173 1.875ZM5.83398 3.125H15.4173C15.7615 3.125 16.0423 3.405 16.0423 3.75V9.16667V11.25C16.0423 11.595 15.7615 11.875 15.4173 11.875H5.83398C5.09982 11.875 4.46482 12.0741 3.95898 12.4233V5C3.95898 3.68583 4.51982 3.125 5.83398 3.125ZM15.4173 16.875H5.83398C4.65982 16.875 3.95898 16.1742 3.95898 15C3.95898 13.8258 4.65982 13.125 5.83398 13.125H15.4173C15.6373 13.125 15.8457 13.0801 16.0423 13.01V16.25C16.0423 16.595 15.7615 16.875 15.4173 16.875ZM6.87565 5.83333C6.87565 5.48833 7.15565 5.20833 7.50065 5.20833H12.5007C12.8457 5.20833 13.1257 5.48833 13.1257 5.83333C13.1257 6.17833 12.8457 6.45833 12.5007 6.45833H7.50065C7.15565 6.45833 6.87565 6.17833 6.87565 5.83333ZM6.87565 8.33333C6.87565 7.98833 7.15565 7.70833 7.50065 7.70833H10.834C11.179 7.70833 11.459 7.98833 11.459 8.33333C11.459 8.67833 11.179 8.95833 10.834 8.95833H7.50065C7.15565 8.95833 6.87565 8.67833 6.87565 8.33333Z",
      fill: "currentColor"
    }));
  };
});
